import type { ReactNode } from 'react';
import { scrollRsElementClearOfMobileSubmitBar } from '../../utils/reservationBoardCalendar.util';
import styles from './ReservationBoardCalendar.module.css';

type RsDetailsToggleProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  summary: ReactNode;
  badge?: ReactNode;
  children: ReactNode;
  className?: string;
};

/** 折りたたみ details（閉じている間は children をマウントしない） */
export default function RsDetailsToggle({
  open,
  onOpenChange,
  summary,
  badge,
  children,
  className,
}: RsDetailsToggleProps) {
  return (
    <details
      className={className}
      open={open}
      onToggle={(e) => {
        const node = e.target as HTMLDetailsElement;
        const next = node.open;
        onOpenChange(next);
        if (!next) return;
        requestAnimationFrame(() => {
          scrollRsElementClearOfMobileSubmitBar(node);
        });
      }}
    >
      <summary className={`small text-muted ${styles.detailsSummary}`}>
        {summary}
        {badge}
      </summary>
      {open ? children : null}
    </details>
  );
}
